import moment from 'moment'
require('moment/locale/pt-br');

export function formatarHoraCurta(data: Date | undefined): string {
    if (!data)
        return "";

    return data.toLocaleTimeString().substring(0, 5);
}

export function formatarDataHoraCurta(dataHora: Date | string | undefined): string {
    if (!dataHora)
        return "";

    const formatador = moment(dataHora);

    return `${formatador.format("DD/MM/YYYY")} às ${formatador.format("HH:mm")}`;
}

export function formatarDataCurta(data: Date | string | undefined): string {
    if (!data)
        return "";

    return moment(data).format("DD/MM/YYYY");
}

export function formatarDataComMesExtenso(dataHora: Date | string | undefined) {
    if (!dataHora)
        return "";

    return moment(dataHora).format('lll');
}